/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Audit_EmptyInputs */

const en_fw_audit_empty = /** @type {(inputs: Fw_Audit_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No workspace yet.`)
};

const id_fw_audit_empty = /** @type {(inputs: Fw_Audit_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada workspace.`)
};

/**
* | output |
* | --- |
* | "No workspace yet." |
*
* @param {Fw_Audit_EmptyInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_audit_empty = /** @type {((inputs?: Fw_Audit_EmptyInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Audit_EmptyInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_audit_empty(inputs)
	return en_fw_audit_empty(inputs)
});